import React from 'react';
import './NewsAbout3.css'
import { textAlign } from '@mui/system';
import Box from '@mui/material/Box';

const NewsAbout3 = () => {
    return (
        <div className="container py-5">


        <Box className='news3-box' sx={{ height: '100%' }}>
        <div >
           
           <h1 className="news3-heading text-primary">Annual Conference 2022: 50 Years of Japan-Bangladesh <br /> relationship  and opportunities for future collaboration
</h1>   
<br />

<p sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">
  <span className='fw-bolder'>Date: </span>2-3 July 2022 <br />
  <span className='fw-bolder'>Time: </span>9.00 am to 5.00 pm, Japan Time
 <br />
  <span className='fw-bolder'>Venue: </span> Online
 <br />
<br />
Japan -Bangladesh relationship was established on 10 February 1972. In 2022 It will reach 50 years. Japan is already recognized as the best friendly country for Bangladesh considering diplomatic relations and foreign aid. We believe that this relationship will be stronger and more impactful in near future. Japanese ideology for industry and social development always inspires us and we want to make it more impactful for the young generations. On this remarkable occasion, we would like to organize two days international conference virtually to show the 50 years' achievements of Japan-Bangladesh relationships as well as the future opportunities to move forward. Bangladeshi students in Japan, any Bangladeshi citizen in Japan, and Bangladeshi students from Bangladesh and any interested person will be able to participate in this conference. Japanese and Bangladeshi professors, researchers, entrepreneurs, community leaders, youth leaders will be the speaker to share the success and future opportunities from different perspectives. Also, we will publish a hardcopy souvenir to make an archive in one book bringing some remarkable stories of this relationship as well as stories of successful Bangladeshi entrepreneurs in Japan.

</p>
<br />
<h6 className='list-item text-primary'> Objectives:</h6>
<ul sx={{textAlign: 'justify', color: '#354252' }} className="news3 container fs-6">
<li className='list-item'>Highlight the 50 years support of Japan for Bangladesh</li>
  <li className='list-item'>To make an understanding for Bangladeshi people especially for youth about status and future trend of Japan-Bangladesh relationship impact

</li>

  <li className='list-item'>To make a learning statement from Japanese economic miracle and social development for the Bangladeshi people
</li>
<li className='list-item'>To find out the new opportunities for future collaboration through knowledge and resource exchange between Bangladesh and Japan

</li>
</ul>

<h1 className="news3-heading text-primary mt-5">Outline</h1>
<p sx={{textAlign: 'justify', color: '#354252' }} className="news1 container fs-6">Two days conference will be held in online for them, who are doing or interested to do entrepreneurial activity. There will be 10 sessions to cover 10 topics relevant to the title. Participants will be able to know the previous success and future opportunity and they will be able to plan for their future work for business or social development initiatives. They will get direction how to design their entrepreneurship to work with Japan for the economic and social development of Bangladesh and strengthen relationship between Bangladesh and Japan. We will also highlight SDG issue. We are expecting registered participants from Japan about 200 and from Bangladesh about 300 in total 500 from diverse background including students, teacher, researcher, housewife, businessman, job holder, social activist, government officials. We will publish a souvenir covering the success stories of Bangladeshi entrepreneurs in japan as well as some articles about the previous success and future opportunities of Japan-Bangladesh relationship.
</p>

</div>
            </Box> 



    </div>
    );
};

export default NewsAbout3;